// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FABg1","right":"styles_right__13NRu"};